import scrollTop from './components/scrollTop';
import footerMobile from './components/footerMobile';
import menuMobile from './components/menuMobile'
import planSlider from './components/planSlider';
import selectInput from './components/selectInput';
// import faq from './components/faq';
import initializeFlickity from './components/initializeFlickity';
import newsSideToggle from './components/newsSideToggle';
import cart from './components/cart';
import popup from './components/popup';
import jossStick from './components/jossStick';
import getAddress from './components/getAddress';
import contact from './components/contact';
import adjustFont from './components/adjustFont';
import invoicePay from './components/invoicePay';

document.addEventListener(
  'DOMContentLoaded',
  () => {

    // faq();
    menuMobile();
    footerMobile();
    selectInput();
    planSlider();
    initializeFlickity();
    newsSideToggle();
    cart();
    popup();
    jossStick();
    getAddress();
    contact();
    adjustFont();
    invoicePay();

    window.onscroll = () => {
      scrollTop();
    }
  },
  false
);
